// extracted by mini-css-extract-plugin
module.exports = {"card-cont":"team_card-cont__BG3_V","card-img-cont":"team_card-img-cont__GU43N","card-person-name":"team_card-person-name___dyNm","card-person-role":"team_card-person-role__uLh3X"};